module.exports = __webpack_public_path__ + "img/48e6370.png";